import { render } from "./Sign.vue?vue&type=template&id=0b34f775"
import script from "./Sign.vue?vue&type=script&lang=ts"
export * from "./Sign.vue?vue&type=script&lang=ts"

import "./Sign.vue?vue&type=style&index=0&id=0b34f775&lang=css"
script.render = render

export default script